import { QuestionBase } from './question-base.model';

export class InputSearch extends QuestionBase<string> {
    controlType = 'inputSearch';
    datasource: any;
    visible: string;
    hint: string
    clearSearch: boolean;
    showAdvSearch: boolean;
    constructor(options: {} = {}) {
        super(options);
        this.datasource = options['datasource'];
        this.hint = options['hint']
        this.clearSearch = options['clearSearch']
        this.showAdvSearch = options['showAdvSearch']
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
    }
}
